/* decision-system.js — live Decision System summary + add-to-cart.
   No fetches on load; reads an inline JSON island. Adds to the existing Dawn drawer. */
(function () {
  if (window.__dsBound) return;
  window.__dsBound = true;

  // ---- shared cart state (one fetch, shared by all modules) ----
  var CartState = {
    productIds: new Set(),   // product-level blocking
    variantIds: new Set(),
    loaded: false,
    subscribers: [],
    fetching: null,
    load: function () {
      if (this.fetching) return this.fetching;
      var self = this;
      this.fetching = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.productIds = new Set();
          self.variantIds = new Set();
          (cart.items || []).forEach(function (it) {
            self.variantIds.add(String(it.id));
            self.productIds.add(String(it.product_id));
          });
          self.loaded = true;
          self.fetching = null;
          self.notify();
          return self;
        })
        .catch(function () { self.fetching = null; self.loaded = true; return self; });
      return this.fetching;
    },
    hasProduct: function (pid) { return this.productIds.has(String(pid)); },
    hasVariant: function (vid) { return this.variantIds.has(String(vid)); },
    onChange: function (fn) { this.subscribers.push(fn); },
    notify: function () { this.subscribers.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  };

  // Re-sync when the cart changes anywhere (Dawn events, our own adds, tab focus).
  function wireCartResync() {
    if (window.__dsCartWired) return;
    window.__dsCartWired = true;
    // Dawn publishes via PubSub; also listen to common custom events + focus.
    document.addEventListener('cart:refresh', function () { CartState.load(); });
    document.addEventListener('cart:updated', function () { CartState.load(); });
    if (window.PubSub && window.PubSub.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.PubSub.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { CartState.load(); });
    }
    // fallback: re-check when the tab regains focus (covers drawer removals, other tabs)
    window.addEventListener('focus', function () { CartState.load(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) CartState.load(); });
  }

  function money(cents, fmt) {
    var v = (cents / 100);
    // handle the common ₹ money formats; fall back to fixed-2 with the symbol from format
    var num = v.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    if (fmt && fmt.indexOf('₹') !== -1) return '₹' + num;
    if (fmt && fmt.indexOf('{{amount_no_decimals}}') !== -1) return '₹' + num;
    return '₹' + num;
  }

  function tierFor(subtotal, tiers) {
    if (subtotal >= tiers.t2.thresh) return { pct: tiers.t2.pct, tier: 2 };
    if (subtotal >= tiers.t1.thresh) return { pct: tiers.t1.pct, tier: 1 };
    return { pct: 0, tier: 0 };
  }

  function initModule(root) {
    if (root.dataset.dsReady) return;
    root.dataset.dsReady = '1';

    var dataEl = root.querySelector('[data-pw-data]');
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fmt = DATA.money_format;

    // ----- state -----
    var state = {
      mainVariant: DATA.main.current,   // main auto-selected
      mainOn: true,
      pairs: {}                         // productId -> {variantId, price, title, image}
    };

    // build a quick lookup of pair products from the cards
    var cards = {};
    root.querySelectorAll('[data-pwc]').forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      var variants = {};
      (card.getAttribute('data-variants') || '').split('|').forEach(function (chunk) {
        var p = chunk.split(':');
        if (p[0]) variants[p[0]] = { price: parseInt(p[1], 10), available: p[2] === 'true', title: p[3] };
      });
      cards[pid] = {
        el: card,
        title: card.querySelector('.pwc-title') ? card.querySelector('.pwc-title').textContent.trim() : '',
        image: card.querySelector('img') ? card.querySelector('img').src : '',
        variants: variants
      };
    });

    // reflect real cart status on each pair card (product-level block)
    function applyCartStatus() {
      Object.keys(cards).forEach(function (pid) {
        var card = cards[pid].el;
        var inCart = CartState.hasProduct(pid);
        card.classList.toggle('pwc--incart', inCart);
        var buy = card.querySelector('.pwc-buy');
        var existing = card.querySelector('.pwc-incart');
        if (inCart) {
          // remove from local selection if it was there (it's really in cart now)
          if (state.pairs[pid]) { delete state.pairs[pid]; }
          if (buy) buy.style.display = 'none';
          if (!existing) {
            var badge = document.createElement('div');
            badge.className = 'pwc-incart';
            badge.innerHTML = '<span class="pwc-incart-tick">✓ In cart</span>' +
              '<a href="/cart" class="pwc-incart-view">View cart</a>';
            (card.querySelector('.pwc-body') || card).appendChild(badge);
          }
        } else {
          if (buy) buy.style.display = '';
          if (existing) existing.remove();
        }
      });
      // main product cart status → used by summary
      state.mainInCart = CartState.hasProduct(DATA.main.id);
      recalc();
    }

    var summary = root.querySelector('[data-pw-summary]');
    var headline = root.querySelector('[data-pw-headline]');
    var itemsWrap = root.querySelector('[data-pw-items]');
    var breakdown = root.querySelector('[data-pw-breakdown]');
    var summaryBody = root.querySelector('[data-pw-summary-body]');
    var summaryToggle = root.querySelector('[data-pw-summary-toggle]');
    var addBtn = root.querySelector('[data-pw-add]');

    // ----- main variant options for the summary row -----
    function mainVariantOptions(selectedId) {
      return DATA.main.variants.map(function (v) {
        var dis = v.available ? '' : ' disabled';
        var sel = String(v.id) === String(selectedId) ? ' selected' : '';
        return '<option value="' + v.id + '"' + dis + sel + '>' + v.title + (v.available ? '' : ' — Sold Out') + '</option>';
      }).join('');
    }
    function pairVariantOptions(pid, selectedId) {
      var vs = cards[pid].variants;
      return Object.keys(vs).map(function (id) {
        var v = vs[id];
        var dis = v.available ? '' : ' disabled';
        var sel = String(id) === String(selectedId) ? ' selected' : '';
        return '<option value="' + id + '"' + dis + sel + '>' + v.title + (v.available ? '' : ' — Sold Out') + '</option>';
      }).join('');
    }

    // ----- recalc + render -----
    function priceOfMain(id) {
      var found = DATA.main.variants.filter(function (v) { return String(v.id) === String(id); })[0];
      return found ? found.price : 0;
    }

    function recalc() {
      var rows = [];
      var subtotal = 0;

      if (state.mainOn && !state.mainInCart) {
        var mp = priceOfMain(state.mainVariant);
        subtotal += mp;
        rows.push({
          kind: 'main', id: DATA.main.id, variant: state.mainVariant,
          title: DATA.main.title, image: DATA.main.image, price: mp,
          badge: DATA.labels.yourItem,
          inCart: false
        });
      }
      Object.keys(state.pairs).forEach(function (pid) {
        var sel = state.pairs[pid];
        subtotal += sel.price;
        rows.push({
          kind: 'pair', id: pid, variant: sel.variantId,
          title: cards[pid].title, image: cards[pid].image, price: sel.price
        });
      });

      var count = rows.length;
      if (count === 0) { summary.hidden = true; return; }
      summary.hidden = false;

      // note when the main item is already in the cart (excluded from this total)
      var mainNote = state.mainInCart
        ? '<div class="pw-mainnote">✓ ' + DATA.main.title + ' is already in your cart. <a href="/cart">View cart</a></div>'
        : '';

      var t = tierFor(subtotal, DATA.tiers);
      var after = Math.round(subtotal - (subtotal * t.pct / 100));

      // headline (collapsed view): total after prepaid
      var headParts = [];
      headParts.push('<b>' + count + ' item' + (count > 1 ? 's' : '') + '</b>');
      if (t.pct > 0) {
        headParts.push('<span class="pw-sum-strike">' + money(subtotal, fmt) + '</span>');
        headParts.push('<span class="pw-sum-final">' + money(after, fmt) + '</span>');
        headParts.push('<span class="pw-sum-tag">' + DATA.labels.afterPrepaid.replace('{pct}', t.pct) + '</span>');
      } else {
        headParts.push('<span class="pw-sum-final">' + money(subtotal, fmt) + '</span>');
      }
      headline.innerHTML = headParts.join(' ');

      // rows (expanded view) — each editable
      itemsWrap.innerHTML = mainNote + rows.map(function (r) {
        var opts = r.kind === 'main' ? mainVariantOptions(r.variant) : pairVariantOptions(r.id, r.variant);
        var badge = r.badge ? '<span class="pw-row-badge' + (r.inCart ? ' pw-row-badge--incart' : '') + '">' + r.badge + '</span>' : '';
        var ctl = r.inCart
          ? '<a href="/cart" class="pw-row-viewcart">View in cart</a>'
          : '<select class="pw-row-size" data-row-size>' + opts + '</select><span class="pw-row-price">' + money(r.price, fmt) + '</span>';
        var removeBtn = r.inCart
          ? ''
          : '<button type="button" class="pw-row-x" data-row-remove aria-label="Remove ' + r.title + '">&times;</button>';
        return '' +
          '<div class="pw-row' + (r.inCart ? ' pw-row--incart' : '') + '" data-row-kind="' + r.kind + '" data-row-id="' + r.id + '">' +
            '<img class="pw-row-img" src="' + r.image + '" alt="">' +
            '<div class="pw-row-mid">' +
              '<div class="pw-row-title">' + r.title + badge + '</div>' +
              '<div class="pw-row-ctl">' + ctl + '</div>' +
            '</div>' +
            removeBtn +
          '</div>';
      }).join('');

      // breakdown line: prepaid vs COD
      var codPct = DATA.tiers.t1.pct; // COD/lower offer proxy; label configurable
      var bParts = [];
      if (t.pct > 0) {
        bParts.push('<span class="pw-bd-main">' + money(after, fmt) + ' <em>' + DATA.labels.afterPrepaid.replace('{pct}', t.pct) + '</em></span>');
      }
      breakdown.innerHTML = bParts.join('');

      // wire row controls
      itemsWrap.querySelectorAll('.pw-row').forEach(function (rowEl) {
        var kind = rowEl.getAttribute('data-row-kind');
        var id = rowEl.getAttribute('data-row-id');
        var removeEl = rowEl.querySelector('[data-row-remove]');
        if (removeEl) removeEl.addEventListener('click', function () {
          if (kind === 'main') { state.mainOn = false; }
          else { delete state.pairs[id]; syncCardVisual(id, false); }
          recalc();
        });
        var sizeEl = rowEl.querySelector('[data-row-size]');
        if (sizeEl) sizeEl.addEventListener('change', function (e) {
          var vid = e.target.value;
          if (kind === 'main') { state.mainVariant = vid; }
          else {
            var price = cards[id].variants[vid] ? cards[id].variants[vid].price : state.pairs[id].price;
            state.pairs[id] = { variantId: vid, price: price };
            // reflect in the card select too
            var cardSel = cards[id].el.querySelector('[data-pwc-select]');
            if (cardSel && cardSel.tagName === 'SELECT') cardSel.value = vid;
          }
          recalc();
        });
      });
    }

    function syncCardVisual(pid, on) {
      var card = cards[pid] && cards[pid].el;
      if (!card) return;
      var btn = card.querySelector('[data-pwc-toggle]');
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.querySelector('.pwc-add-plus').hidden = on;
        btn.querySelector('.pwc-add-check').hidden = !on;
      }
      card.classList.toggle('pwc--on', on);
    }

    // ----- card interactions -----
    root.querySelectorAll('[data-pwc]').forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      var select = card.querySelector('[data-pwc-select]');
      var toggle = card.querySelector('[data-pwc-toggle]');

      function addFromCard() {
        if (CartState.hasProduct(pid)) { return; } // already in cart, block
        var vid = select ? select.value : '';
        if (!vid) { // no size chosen — nudge the select
          if (select && select.tagName === 'SELECT') { select.focus(); select.classList.add('pwc-select--flash'); setTimeout(function(){select.classList.remove('pwc-select--flash');},600); }
          return;
        }
        var price = cards[pid].variants[vid] ? cards[pid].variants[vid].price : 0;
        state.pairs[pid] = { variantId: vid, price: price };
        syncCardVisual(pid, true);
        recalc();
        openSummary();
      }
      function removeFromCard() {
        delete state.pairs[pid];
        syncCardVisual(pid, false);
        recalc();
      }
      if (toggle) toggle.addEventListener('click', function () {
        if (state.pairs[pid]) removeFromCard(); else addFromCard();
      });
      if (select && select.tagName === 'SELECT') {
        select.addEventListener('change', function () {
          if (state.pairs[pid]) { // already selected -> update
            var vid = select.value;
            if (vid) state.pairs[pid] = { variantId: vid, price: cards[pid].variants[vid].price };
            recalc();
          }
        });
      }
    });

    // ----- fit toggle -----
    root.querySelectorAll('.pw-tgl').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.pw-tgl').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        var fit = btn.getAttribute('data-fit');
        root.querySelectorAll('[data-fit-grid]').forEach(function (g) {
          g.style.display = g.getAttribute('data-fit-grid') === fit ? 'flex' : 'none';
        });
      });
    });

    // ----- summary expand/collapse -----
    function openSummary() {
      summaryToggle.setAttribute('aria-expanded', 'true');
      summaryBody.style.display = 'block';
    }
    if (summaryToggle) summaryToggle.addEventListener('click', function () {
      var open = summaryToggle.getAttribute('aria-expanded') === 'true';
      summaryToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      summaryBody.style.display = open ? 'none' : 'block';
    });

    // ----- add all selected to cart -> existing drawer -----
    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [];
      if (state.mainOn && !state.mainInCart) items.push({ id: parseInt(state.mainVariant, 10), quantity: 1, properties: { '_source': 'decision-system' } });
      Object.keys(state.pairs).forEach(function (pid) {
        items.push({ id: parseInt(state.pairs[pid].variantId, 10), quantity: 1, properties: { '_source': 'decision-system-pair' } });
      });
      if (!items.length) return;

      addBtn.querySelector('.pw-add-label').hidden = true;
      addBtn.querySelector('.pw-add-spin').hidden = false;

      var drawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (drawer) { payload.sections = ['cart-drawer']; payload.sections_url = window.location.pathname; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          addBtn.querySelector('.pw-add-label').hidden = false;
          addBtn.querySelector('.pw-add-spin').hidden = true;
          if (window.gtag) window.gtag('event', 'add_to_cart', { source: 'decision-system', value: items.length });
          // clear local selection (now really in cart) and re-sync
          state.pairs = {};
          CartState.load().then(function () { applyCartStatus(); });
          openDrawer(data, drawer);
        })
        .catch(function (e) {
          console.error('[decision-system] add failed', e);
          addBtn.querySelector('.pw-add-label').hidden = false;
          addBtn.querySelector('.pw-add-spin').hidden = true;
        });
    });

    function openDrawer(addData, drawer) {
      if (!drawer) { window.location.href = '/cart'; return; }
      try {
        if (typeof drawer.renderContents === 'function' && addData.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(addData);
          if (typeof drawer.open === 'function') drawer.open();
          return;
        }
      } catch (e) {}
      if (typeof drawer.open === 'function') drawer.open();
    }

    recalc(); // initial paint
    // sync with the real cart
    wireCartResync();
    CartState.onChange(applyCartStatus);
    CartState.load().then(function () { applyCartStatus(); });
  }

  function boot() { document.querySelectorAll('[data-decision-system]').forEach(initModule); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();